<template>
  <el-dialog
    id="email-dialog"
    class="padding-top: 10px;"
    width="80%"
    :title="title"
    :visible.sync="showDialog"
    :modal-append-to-body="true"
    :append-to-body="true"
  >
    <div slot="title" class="dialog-title text-lg">
      {{ title }}
    </div>
    <hr class="mb-2 -mt-2" />

    <div id="form-container" class="pt-2">
      <el-form
        ref="elForm"
        :model="formData"
        :rules="validationRules"
        size="medium"
        label-width="auto"
      >
        <div class="flex flex-col gap-2">
          <el-form-item
            label="Send Failed Notification to"
            class="w-full"
            prop="Email"
            style="margin-bottom: 35px"
          >
            <el-select
              class="w-full"
              v-model="formData.email"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="Email"
            >
              <el-option
                v-for="(item, index) in emailData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <hr class="my-4" />
        <div class="w-full text-right">
          <el-button type="primary" @click="updateEmailData">Submit</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mixin as VueTimers } from 'vue-timers'
// import AppIcon from '@/components/AppIcon'

export default {
  components: {
    // AppIcon
    AppIcon: () => import('@/components/AppIcon')
  },
  props: {
    title: {
      type: String,
      default: 'Alarms'
    },
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      updateEmailLoading: false,
      dialogVisible: false,
      loadingState: false,
      emailData: [],

      formData: {
        email: []
      },
      validationRules: {
        Email: [
          {
            required: true,
            message: 'Email is required',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.fetchEmailData()
  },
  methods: {
    async fetchEmailData() {
      try {
        const { data: res } = await this.$axios.get(
          this.$appInfo.api.manualConfig.getEmailFailedDestination
        )
        this.emailData = res
        this.formData.email = res
      } catch (error) {
        console.log(error)
      }
    },
    async updateEmailData() {
      try {
        this.updateEmailLoading = true
        this.$axios.put(
          this.$appInfo.api.manualConfig.updateEmailNotifDestination,
          this.formData.email
        )
        this.showDialog = false
        this.updateEmailLoading = false
        this.formData.email = []
      } catch (error) {
        this.updateEmailLoading = false
        console.log(error)
      }
    }
  },
  watch: {
    dialogVisible: {
      deep: true,
      handler(val) {
        if (!val) {
          this.$emit('onClose', val)
        }
      }
    },
    showDialog: {
      deep: true,
      handler(val) {
        this.dialogVisible = val
        this.fetchEmailData()
      }
    }
  }
}
</script>

<style>
.list-alarm:nth-child(even) {
  background-color: #f2f2f2;
}
#email-dialog .el-dialog__body {
  padding: 10px 20px 20px;
}
</style>
